export class DependencyLicenseModel {
  licenses: 'MIT' | string;
  repository: string;
  publisher: string;
  email: string;
  name: string;
  version: string;
  description: string;
  copyright: string;
  licenseFile: string;
  licenseText: string;
  path: string;
}
